<template>
  <router-link :to="to" class="event-card no-link">
    <v-img class="elevation-4" :aspect-ratio="1" :src="img" :alt="title" v-ripple>
      <template v-slot:placeholder>
        <div class="icon d-flex justify-center align-center">
          <v-icon class="d-block" x-large>mdi-calendar</v-icon>
        </div>
      </template>
      <div class="title d-flex justify-center align-center">
        <h3 class="text-center white--text">{{ title }}</h3>
      </div>
    </v-img>
  </router-link>
</template>

<script>
export default {

  props: ['title', 'to', 'img'],
  computed: {
    time() {
      return new Intl.DateTimeFormat('pt-BR').format(new Date(this.date))
    }
  }
}
</script>

<style>
.event-card {
  height: 100%;
  min-height: 160px;
}
.event-card .event {
  height: 100% !important;
  width: 100% !important;
  overflow: hidden;
  background: #fff;
  position: relative;
}
.event-card img {
  object-fit: cover;
  border-radius: 4px;
}
.event-card .title {
  height: 100%;
  background:linear-gradient(to bottom, transparent 0%, #00000096 40%, #00000096 56%, transparent 100%);
}

.event-card .icon {
  height: 100%;
}
.event-card h5 {
  white-space: normal;
}
</style>